import Carousel from 'react-bootstrap/Carousel';
import { Container } from 'react-bootstrap';


export default function CarouselHome() {
  return (
    <>
    <Container fluid>
    <Carousel variant="light">
      <Carousel.Item>
        <img
          className=" d-block w-100 h-70"
          src= 'https://images.pexels.com/photos/147637/pexels-photo-147637.jpeg?cs=srgb&dl=pexels-lalesh-aldarwish-147637.jpg&fm=jpg'
          alt="First slide"
        />
        <Carousel.Caption>
          <h3>Necklace</h3>
          <p>Hypo-Allergenic Necklace</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className=" d-block w-100 h-70"
          src="https://images.pexels.com/photos/234798/pexels-photo-234798.jpeg"
          alt="Second slide"
        />

        <Carousel.Caption>
          <h3>Bracelet</h3>
          <p>Charm Bracelet</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className=" d-block w-100 "
          src="https://images.pexels.com/photos/119550/pexels-photo-119550.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          alt="Third slide"
        />

        <Carousel.Caption>
          <h3>Apple Mouse</h3>
          <p>
            Mouse compatible to your Macbook 
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
    </Container>
    </>
  );
}

